import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'
import envs from '@/envs'

export function getSiteList(params) {
  return request({
    url: '/master/site/getSiteList',
    method: 'post',
    data: params,
    meta: { useAuth: true }
  })
}

export function getSiteDetail(params) {
  return request({
    url: '/master/site/getSiteDetail',
    method: 'post',
    data: params,
    meta: { useAuth: true }
  })
}

export function getSiteEssDetail(params) {
  return request({
    url: '/master/site/getSiteEssDetail',
    method: 'post',
    data: params,
    meta: { useAuth: true }
  })
}

export function getOnlyCapa(params) {
  return request({
    url: '/master/site/getOnlyCapa',
    method: 'POST',
    meta: {
      apiVersion: 'v1.0'
    },
    data: params
  })
}

export function checkSession() {
  return request({
    url: '/master/site/checkSession',
    method: 'POST'
  })
}

export function setSiteMaster(params) {
  return request({
    url: '/master/site/setSiteMaster',
    method: 'POST',
    data: params,
    meta: { useAuth: true }
  })
}

export function setSiteEssMaster(params) {
  return request({
    url: '/master/site/setSiteEssMaster',
    method: 'POST',
    data: params,
    meta: { useAuth: true }
  })
}

export function setSiteDelete(params) {
  return request({
    url: '/master/site/setSiteDelete',
    method: 'DELETE',
    data: params,
    meta: { useAuth: true }
  })
}

export function setMigration(params) {
  return request({
    url: '/master/site/setMigration',
    method: 'POST',
    data: params,
    meta: { useAuth: true }
  })
}

export function streamEvent(params, method, url) {
  url = envs.WowzaMgIpAddress + url
  return request({
    url: url,
    method: method,
    data: params
  })
}

/* 사이트 청구관리 추가 2019-11-01 */
export function getSiteBillMngtList(params) {
  return request({
    url: '/master/site/getSiteBillMngtList',
    method: 'POST',
    data: params,
    meta: { useAuth: true }
  })
}

export function sendBillSms(params) {
  return request({
    url: '/master/site/sendBillSms',
    method: 'POST',
    data: params,
    meta: { useAuth: true }
  })
}

export function getSiteBillMngtDetail(params) {
  return request({
    url: '/master/site/getSiteBillMngtDetail',
    method: 'POST',
    data: params,
    meta: { useAuth: true }
  })
}

export function setSiteBillMngtMaster(params) {
  return request({
    url: '/master/site/setSiteBillMngtMaster',
    method: 'POST',
    data: params,
    meta: { useAuth: true }
  })
}

export function delSiteBillMngt(params) {
  return request({
    url: '/master/site/deleteSiteBillMngt',
    method: 'DELETE',
    data: params,
    meta: { useAuth: true }
  })
}

export function getBillMngCodeList(params) {
  return request({
    url: '/master/site/getBillMngCodeList',
    method: 'POST',
    data: params,
    meta: { useAuth: true }
  })
}

export function sendBillKakao(params) {
  return request({
    url: '/master/site/sendBillKakao',
    method: 'POST',
    data: params,
    meta: { useAuth: true }
  })
}

export function sendKakaoDt(params) {
  return request({
    url: '/master/site/sendKakaoDt',
    method: 'POST',
    data: params,
    meta: { useAuth: true }
  })
}

export function sendAlimtalk(params) {
  return request({
    url: '/master/site/sendAlimtalk',
    method: 'POST',
    data: params,
    timeout: 1000 * 60 * 20,
    meta: { useAuth: true }
  })
}
